<script>
	export default {
		name: 'CookieExecuter',
		methods: {
			getCookie(name) {
				const self_ = this;
				return self_.jsCookie.get(name)
			},
			setCookie(name, value) {
				const self_ = this;
				self_.jsCookie.set(name, value)
			},
			removeCookie(name) {
				const self_ = this;
				self_.jsCookie.remove(name)
			}
		}
	}
</script>